import { ContractConfig } from '../types';

// Contract ABI - extracted from the contract data
export const CONTRACT_ABI = [
  "function currentSupply() external view returns (uint256)",
  "function tokenURI(uint256 tokenId) external view returns (string)",
  "function ownerOf(uint256 tokenId) external view returns (address)",
  "function getTokenSiteMetadata(uint256 tokenId) external view returns (string name, string url)",
  "function getTokenTraitVersion(uint256 tokenId) external view returns (uint8)",
  "function isNFTFinalized(uint256 tokenId) external view returns (bool)",
  "function getNFTCustomTraitCount(uint256 tokenId) external view returns (uint256)",
  "function getTentacleTraitsData(uint256 tokenId) external view returns (string[6] names, string[6] svgs, uint256[6] rarities, bool[6] isCustom)",
  "function hasCustomBackground(uint256 tokenId) external view returns (bool)",
  "function getCustomBackgroundSVG(uint256 tokenId) external view returns (string)",
  "function getBackgroundTraitSVG(uint256 tokenId) external view returns (string)",
  "function getTentacleTraitSVG(uint256 tokenId, uint256 tentacleIndex) external view returns (string)",
  "function getTentacleStatus(uint256 tokenId) external view returns (bool[6])",
  "function getTokenSeed(uint256 tokenId) external view returns (bytes32)",
  "function name() external view returns (string)",
  "function symbol() external view returns (string)"
];

// Get contract configuration from environment variables
export const getContractAddresses = (): string[] => {
  const env = ((import.meta as any)?.env || (typeof window !== 'undefined' && (window as any).__ENV__) || {}) as Record<string, string>;
  const raw = (env.VITE_CONTRACT_ADDRESS || '').trim();
  if (!raw) throw new Error('VITE_CONTRACT_ADDRESS is required (comma-separated allowed)');
  return raw
    .split(',')
    .map((s: string) => s.trim())
    .filter((s: string) => s.length > 0);
};

export const getContractConfig = (): ContractConfig => {
  const env = ((import.meta as any)?.env || (typeof window !== 'undefined' && (window as any).__ENV__) || {}) as Record<string, string>;
  return {
    rpcUrl: env.VITE_RPC_URL || 'https://sepolia.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161',
  };
};
